(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vacant-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  if (event.target instanceof Element && event.target.closest('.vacant-menu a')) {
    event.target.closest('.vacant-menu').removeAttribute('open');
  }
});
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    document.querySelectorAll('.vacant-menu[open]').forEach((menu) => {
      menu.removeAttribute('open');
      menu.querySelector('summary').focus();
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
